{
  "+{{count}} Hold_one": "+{{count}} Hold",
  "+{{count}} Hold_other": "+{{count}} Holds",
  "+{{count}} New_one": "+{{count}} New",
  "+{{count}} New_other": "+{{count}} New",
  "<0><0>Calling from</0> <2>{selectedOutboundPhoneNumber\n                    ? formatPhoneNumber(selectedOutboundPhoneNumber.number)\n                    : 'Unknown number'}</2></0>": "<0><0>Calling from</0> <2>{selectedOutboundPhoneNumber\n                    ? formatPhoneNumber(selectedOutboundPhoneNumber.number)\n                    : 'Unknown number'}</2></0>",
  "<0>Please try restarting your Softphone. If the issue persists, please contact <2>Weave Support</2>.</0>": "<0>Please try restarting your Softphone. If the issue persists, please contact <2>Weave Support</2>.</0>",
  "<0>You will be unable to place calls or receive calls through the Weave app. Incoming calls to this extension will be redirected to voicemail.</0><1>You can reconnect your Softphone or connect another device under the <2>Device Connection</2> page in your Personal Settings. Are you sure you want to disconnect your Softphone?</1><2>Are you sure you want to disconnect your softphone?</2>": "<0>You will be unable to place calls or receive calls through the Weave app. Incoming calls to this extension will be redirected to voicemail.</0><1>You can reconnect your Softphone or connect another device under the <2>Device Connection</2> page in your Personal Settings. Are you sure you want to disconnect your Softphone?</1><2>Are you sure you want to disconnect your softphone?</2>",
  "Add Call": "Add Call",
  "Add New Call": "Add New Call",
  "Answer": "Answer",
  "Audio Settings": "Audio Settings",
  "Back to Call": "Back to Call",
  "Call Waiting Indicator Beep": "Call Waiting Indicator Beep",
  "Call has already ended.": "Call has already ended.",
  "Calls on Local Hold": "Calls on Local Hold",
  "Cancel": "Cancel",
  "Change Device": "Change Device",
  "Contacts": "Contacts",
  "Copy phone number": "Copy phone number",
  "Dial": "Dial",
  "Disconnect Softphone": "Disconnect Softphone",
  "Do Not Disturb (DND)": "Do Not Disturb (DND)",
  "Don't show this message again": "Don't show this message again",
  "E911 Address": "E911 Address",
  "Extension {{extensionNumber}}": "Extension {{extensionNumber}}",
  "Extensions": "Extensions",
  "Give Microphone Access": "Give Microphone Access",
  "Group Call": "Group Call",
  "HOLD": "HOLD",
  "Hold": "Hold",
  "Incoming Call": "Incoming Call",
  "Initializing Softphone...": "Initializing Softphone...",
  "Input": "Input",
  "Invalid transfer destination": "Invalid transfer destination",
  "It looks like you have Weave open on multiple tabs while on an active call. Please return to the tab with your active call and close all other tabs to prevent losing your active call or missing incoming calls.": "It looks like you have Weave open on multiple tabs while on an active call. Please return to the tab with your active call and close all other tabs to prevent losing your active call or missing incoming calls.",
  "It looks like you have Weave open on multiple tabs while you're connected to a Softphone. Your Softphone can only be used in one tab. You can return to the original tab or use the Softphone in this tab.": "It looks like you have Weave open on multiple tabs while you're connected to a Softphone. Your Softphone can only be used in one tab. You can return to the original tab or use the Softphone in this tab.",
  "Keypad": "Keypad",
  "Last Called": "Last Called",
  "Last Called: {{time}}": "Last Called: {{time}}",
  "Loading": "Loading",
  "Manage": "Manage",
  "Manage Participants": "Manage Participants",
  "Merge": "Merge",
  "Merge Calls": "Merge Calls",
  "Microphone": "Microphone",
  "Most Contacted": "Most Contacted",
  "Multiple Softphones Detected": "Multiple Softphones Detected",
  "Multiple Tabs Detected": "Multiple Tabs Detected",
  "Mute": "Mute",
  "New Call": "New Call",
  "No Internet Connection.": "No Internet Connection.",
  "No Microphone Access.": "No Microphone Access.",
  "No Parked Calls": "No Parked Calls",
  "No Transfer Target": "No Transfer Target",
  "On Hold For Warm Transfer": "On Hold For Warm Transfer",
  "On Local Hold": "On Local Hold",
  "Page Not Found": "Page Not Found",
  "Park": "Park",
  "Park Call with {{name}}": "Park Call with {{name}}",
  "Park ringback from {{name}} on Hold {{slot}}": "Park ringback from {{name}} on Hold {{slot}}",
  "Parked Calls": "Parked Calls",
  "Please allow microphone access to use your Softphone.": "Please allow microphone access to use your Softphone.",
  "Please check your network connection and try again.": "Please check your network connection and try again.",
  "Restart Softphone": "Restart Softphone",
  "Retrying in": "Retrying in",
  "Saved Ring Settings": "Saved Ring Settings",
  "Select an Address": "Select an Address",
  "Softphone Settings": "Softphone Settings",
  "Speakers": "Speakers",
  "Successfully copied phone number": "Successfully copied phone number",
  "Successfully parked call in {{name}}": "Successfully parked call in {{name}}",
  "Successfully transferred call with {{name}}": "Successfully transferred call with {{name}}",
  "Swap Call": "Swap Call",
  "System Default Speaker Device": "System Default Speaker Device",
  "Test": "Test",
  "Test Speaker Audio": "Test Speaker Audio",
  "This address should be your physical location.": "This address should be your physical location.",
  "Transfer": "Transfer",
  "Turning on Do Not Disturb (DND) will stop all inbound calls to your softphone.": "Turning on Do Not Disturb (DND) will stop all inbound calls to your softphone.",
  "Unable to save Ring Settings. Please try again.": "Unable to save Ring Settings. Please try again.",
  "Unknown Caller": "Unknown Caller",
  "Use Softphone in This Tab": "Use Softphone in This Tab",
  "We’re having trouble registering your Softphone.": "We’re having trouble registering your Softphone.",
  "You will hear a beep when an incoming call is received while you are on an active call.": "You will hear a beep when an incoming call is received while you are on an active call.",
  "Your softphone has been detected in another application. Please close your other browser or application to use your softphone here. Refresh the page to try again.": "Your softphone has been detected in another application. Please close your other browser or application to use your softphone here. Refresh the page to try again.",
  "{{deviceName}}": "{{deviceName}}",
  "{{name}}": "{{name}}"
}
